
import { COUNTRIES, CURRENCY, cuit_cuil } from '@constants';

export const fields = {
    CO: { 
        client_number: '',
        property_name: '',
        holder_name: '',
        email: '',
        invoice_number: '',
        amount: '',
        conditions: false,
        // specifics
        country: COUNTRIES.CO,
        currency: CURRENCY.CO,
        bank_code: '',
        account_type: '',
        account_number: '',
        document_number: ''
    },
    AR: {
        client_number: '',
        property_name: '',
        holder_name: '',
        email: '',
        invoice_number: '',
        amount: '',
        conditions: false,
        document_type: cuit_cuil,
        // specifics
        country: COUNTRIES.AR,
        currency: CURRENCY.AR,
        cbu: '',
        cuit: ''        
    }
}